import React from 'react';
import classnames from 'classnames';
import { Button } from 'tea-component';

import type { IBaseProps } from '@home/types/common';
import type { IUploadStatus } from '@gp/components/CoverUploader/types';

export interface ICoverBtnsProps extends IBaseProps {
  // 状态
  status?: IUploadStatus;
  // 取消上传
  onCancel?: () => void;
  // 点击Upload Again按钮的回调
  onUploadAgain?: () => void;
  // 点击Delete按钮的回调
  onDelete?: () => void;
}

const SPECIAL_STATUS = ['success', 'error'];

const CoverBtns: React.FC<ICoverBtnsProps> = (props) => {
  const { style, className, status, onCancel, onUploadAgain, onDelete } = props;

  // 上传中的 操作按钮，包含取消上传
  const uploadingBtns = (
    <>
      <Button
        type="link"
        onClick={(e) => {
          e?.stopPropagation();
          onCancel?.();
        }}
      >
        Cancel Upload
      </Button>
    </>
  );

  // 上传成功、上传失败、文件校验失败时的操作按钮，包含重新上传、删除
  const specialStatusBtns = (
    <>
      <Button
        type="link"
        onClick={(e) => {
          e?.stopPropagation();
          onUploadAgain?.();
        }}
      >
        Upload Again
      </Button>
      <Button
        type="link"
        onClick={(e) => {
          e?.stopPropagation();
          onDelete?.();
        }}
      >
        Delete
      </Button>
    </>
  );

  // 右上角的操作按钮
  const operationBtns = (() => {
    if (!status) return null;
    // 上传中，支持取消上传
    if (status === 'uploading') return uploadingBtns;
    // 上传成功、上传失败（包含检验失败）时，支持重新上传、删除
    if (SPECIAL_STATUS.includes(status)) return specialStatusBtns;
  })();

  return (
    <div style={style} className={classnames('dbg-game-overview-message-cover-btns', className)}>
      {operationBtns}
    </div>
  );
};

export default CoverBtns;
